module.exports = __webpack_public_path__ + "4e9234a0ba061604e8305900f3cd6b78.mp4";